const renting_apartment = `Hei, olen kiinnostunut vuokraamaan 1 makuuhuoneen asunnon.
Voisitteko antaa minulle tietoja vuokrasta ja vaadittavasta alkutakuusta?
Haluaisin myös tietää milloin asunto olisi vapaana muuttoa varten.
Kiitos avustanne.`;
export default renting_apartment;